var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2560.000000pt",
    height: "2560.000000pt",
    viewBox: "0 0 2560.000000 2560.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,2560.000000) scale(0.100000,-0.100000)",
    fill: "#ff1d25",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7445 21769 c-620 -26 -1254 -164 -1843 -400 -176 -71 -580 -271 -742 -369 -425 -256 -755 -513 -1101 -859 -428 -429 -748 -866 -1020 -1396 -315 -613 -507 -1255 -585 -1955 -21 -195 -30 -753 -15 -931 57 -646 246 -1279 591 -1974 513 -1036 1322 -2096 2488 -3262 530 -529 1040 -995 1892 -1729 931 -801 2564 -2296 4933 -4516 542 -508 553 -517 687 -538 86 -13 176 1 257 41 49 24 117 81 320 272 2471 2318 4224 3925 5203 4767 1368 1177 2212 2003 2960 2895 1215 1450 1867 2781 1980 4043 16 177 8 736 -14 932 -78 700 -271 1344 -585 1955 -275 533 -590 965 -1021 1396 -344 345 -674 603 -1100 859 -162 98 -566 298 -742 369 -1491 599 -3158 532 -4586 -183 -902 -452 -1679 -1154 -2221 -2009 -108 -170 -242 -411 -320 -579 l-64 -136 -106 212 c-286 575 -638 1056 -1102 1511 -900 880 -2053 1424 -3305 1560 -133 14 -548 36 -624 33 -19 0 -116 -5 -215 -9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.d3b685b7a413f37fbac847c9528ebd82.svg";
export { ForwardRef as ReactComponent };